import { render, staticRenderFns } from "./LoanPortfolioRiskSummary.vue?vue&type=template&id=4c87af31&"
import script from "./LoanPortfolioRiskSummary.vue?vue&type=script&lang=js&"
export * from "./LoanPortfolioRiskSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports